import {Injectable} from '@angular/core';
import {from, Observable, throwError} from "rxjs";
import {MtToken} from "../../models/mt-token";
import {CookieStorage} from "cookie-storage";
import {OAuthService} from "angular-oauth2-oidc";
import {catchError} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ModulTozsamosciService extends OAuthService {

  private cookieStorage = new CookieStorage();

  getParsedToken(): MtToken {
    if (this.isAuthenticated()) {
      const token: string[] = this.getAccessToken().split('.');
      return {
        header: JSON.parse(atob(token[0])),
        payload: JSON.parse(atob(token[1])),
        signature: null
      };
    }
    return null;
  }

  isAuthenticated() {
    return this.hasValidAccessToken() && this.getAccessToken !== null;
  }

  getUserName(): string {
    return this.getClaimsValue('name');
  }

  getDispayName() {
    return this.getClaimsValue('display_name');
  }

  getLoggedDispayName() {
    return this.getClaimsValue('logged_display_name');
  }

  getUserGivenName(): string {
    return this.getClaimsValue('given_name');
  }

  getUserFamilyName(): string {
    return this.getClaimsValue('family_name');
  }

  getUserPreferredUserName(): string {
    return this.getClaimsValue('preferred_username');
  }

  getUserEmail(): string {
    return this.getClaimsValue('email');
  }

  getUserId(): string {
    return this.getParsedToken()?.payload?.user_id;
  }

  getNewAccessToken(): Observable<any> {
    return from(this.refreshToken())
      .pipe(
        catchError((err) => {
          this.logOut();
          return throwError(err)
        })
      );
  }

  getRefreshTokenExpiration(): number {
    const refreshToken = this.cookieStorage.getItem('refresh_token');
    if (!refreshToken) {
      this.logOut();
      return 0;
    }
    const parsedToken = JSON.parse(atob(refreshToken.split('.')[1]));
    return parsedToken.exp;
  }

  private getClaimsValue(key: string): string {
    const claims = this.getIdentityClaims();
    if (!claims) return null;
    return claims[key];
  }

}
